import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../../../shared/components/dialog/Dialog";
import { Button } from "../../../../../../shared/components/button/Button";
import { useTranslation } from "react-i18next";
import ClientPlatformMarginsChangelogTable from "./ClientPlatformMarginsChangelogTable";

const ClientPlatformMarginsChangelogDialog = ({
  id,
  records,
  externalOpen,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setIsOpen(externalOpen?.externalOpen);
  }, [externalOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen} defaultOpen={false}>
      <DialogTrigger asChild className="hidden">
        <Button>x</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("clientPlatformMargins.changelog.title")}
          </DialogTitle>
          <DialogDescription>
            {t("clientPlatformMargins.changelog.description", { id: id })}
          </DialogDescription>
        </DialogHeader>
        <ClientPlatformMarginsChangelogTable data={records} />
      </DialogContent>
    </Dialog>
  );
};

export default ClientPlatformMarginsChangelogDialog;
